var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "12", height: "24", viewBox: "0 0 12 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.78033 15.9697C9.07322 16.2626 9.07322 16.7374 8.78033 17.0303C8.48744 17.3232 8.01256 17.3232 7.71967 17.0303L3.21967 12.5303C2.92678 12.2374 2.92678 11.7626 3.21967 11.4697L7.71967 6.96967C8.01256 6.67678 8.48744 6.67678 8.78033 6.96967C9.07322 7.26256 9.07322 7.73744 8.78033 8.03033L4.81066 12L8.78033 15.9697Z", fill: "#018489" })
  );
});